import { Div2Floor } from "./Div2Floor";
import { XML_DrawLine } from "./XML_DrawLine";

export function XML_DrawDashLine(x, y, width, height, fillColor, drawElement, layer) {
  var my = y + Div2Floor(height);
  var x1 = x + 1;
  var x2 = x + width - 2;

  XML_DrawLine(x1, my, x2, my, fillColor, 2, true, drawElement, layer);
}
